package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_02_17_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-02-17")
@Composable
public fun Log_2023_02_17(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Cave of the Abyss",
        ogTitle = "The Cave of the Abyss",
        date = LocalDate(2_023, 2, 17),
        ogDescription = "The heroes infiltrate a cave, defeat a demonic creature, and recover a magical triangle shard and lost guards.",
        ogImage = "ai/2023-02-17.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-12", dateString = "Newgrowth 12")
        Log_2023_02_17_Day_1()
    }
}
